import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  DistributionPointProperties,
  MultiPointData,
} from '../span-progress-entities';

export enum MultiPointTabs {
  HC,
  HP,
  WELL,
}

export interface ModalState<T = undefined> {
  open: boolean;
  data?: T;
  multiPoint?: MultiPointModalData;
}

export interface MultiPointModalData {
  data: MultiPointData;
  tabs: MultiPointTabs[];
}

export interface PartialDPP {
  sourceKey: string;
  leadId: string;
  name: string;
  id: string;
}

export interface ModalsState {
  ordersOverviewModal: ModalState<any>;
  installationReportModalV2: ModalState<
    DistributionPointProperties | PartialDPP
  >;
  multiPointModal: ModalState<any>;
}

const initialModalState: ModalsState = {
  ordersOverviewModal: {
    open: false,
  },
  installationReportModalV2: {
    open: false,
  },
  multiPointModal: {
    open: false,
  },
};

@Injectable({ providedIn: 'root' })
export class ReportModalService {
  private modalState$ = new BehaviorSubject<ModalsState>(initialModalState);

  getModalState$() {
    return this.modalState$.asObservable();
  }

  setModalState(state: Partial<ModalsState>) {
    this.modalState$.next({ ...this.modalState$.getValue(), ...state });
  }
}
